(function () {
  'use strict';

  angular
    .module('dailyOpsReport')
    .config(config);

  function config($stateProvider) {
    $stateProvider
      .state('dailyOpsReport', {
        url: '/daily-ops-report',        
        views:{
        	'dailyOpsReportView' : {
        		templateUrl: 'daily-ops-report/views/daily-ops-report.tpl.html',
                controller: 'DailyOpsReportCtrl',
                controllerAs: 'dailyOpsReport'
        	}
        }
        
      });
  }
}());
